export const isInitialState = obj => {
  return Object.values(obj).every(val => val === true);
};
